import { render, staticRenderFns } from "./VerticalNavMenuHeader.vue?vue&type=template&id=80833678&scoped=true"
import script from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuHeader.vue?vue&type=style&index=0&id=80833678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80833678",
  null
  
)

export default component.exports